// extracted by mini-css-extract-plugin
export default {"main":"modal_main__SBAyC","modalContainer":"modal_modalContainer__vguDa"};